import { render, staticRenderFns } from "./pos.vue?vue&type=template&id=3c5dd5d2&"
import script from "./pos.vue?vue&type=script&lang=ts&"
export * from "./pos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports